import {
  Chip,
  Grid,
} from "@mui/material";
import { mapStatus } from "../utils/functions";

const DeliveryChips = ({ deliveriesCount, counters, counterLabels }) => {
  const countersMap = new Map(
    counters.map(counter => [counter.value, counter.count])
  );

  return (
    <Grid container>
      <Grid item xs={12} className="chip-btn-container">
        <Grid item md={12}>
          <Chip
            label={`${deliveriesCount || 0} Deliveries en total`}
            variant="outlined"
            color="success"
          />
          {counterLabels &&
            counterLabels.map(({ value, label }) => {
              const count = countersMap.get(value) || 0;

              return (
                <Chip
                  key={value}
                  label={`${count} ${mapStatus(value)}`}
                  variant="contained"
                />
              )
            })}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DeliveryChips;